// extracted by mini-css-extract-plugin
export default {"root":"_g2DpJ05be0R1y8oNE1I","items":"DM8Ursx2b_eXLNjDa25t","item":"bCjO4LrEEViKt3q1XyhC","link":"k2HzFNLhei2LpV5Ln6mH"};